import styled from 'styled-components';

export const Container = styled.div<{ isActive: boolean }>`
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 128px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.06s;
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.palette.persianRed : theme.palette.gray87};
  box-shadow: ${({ isActive }) =>
    isActive ? ' 0px 10px 10px rgba(255, 65, 57, 0.2)' : 'none'};

  background-color: ${({ isActive, theme }) =>
    isActive ? theme.palette.persianRed : theme.palette.white};
`;
export const RoomName = styled.span<{ isActive: boolean }>`
  font-weight: 600;
  font-size: 18px;
  height: 46px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 23px;
  white-space: normal;
  margin-bottom: 8px;
  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.white : theme.palette.darkGrey};
`;

export const PriceWrapper = styled.span<{ isActive: boolean }>`
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  display: block;

  & div {
    color: ${({ isActive, theme }) =>
      isActive ? theme.palette.white : theme.palette.persianRed};
  }
`;

export const SubLabel = styled.span<{ isActive: boolean }>`
  font-weight: 600;
  font-size: 12px;
  line-height: 19px;
  display: block;

  color: ${({ isActive, theme }) =>
    isActive ? theme.palette.white : theme.palette.grey};
`;

export const ActiveItemMark = styled.div`
  background: ${({ theme }) => theme.palette.persianRed};
  border-radius: 2px;
  transform: rotate(-224deg) translateX(-50%);
  position: absolute;
  width: 23px;
  height: 18px;
  bottom: -12px;
  left: 45%;
  z-index: 10;

  @media only screen and (max-width: 375px) {
    bottom: -10px;
    width: 15px;
    height: 14px;
  }
`;
